import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { isStringArray } from 'components/common/dataGrid/filterGuards';
import { IssueStageFilterInput } from '../issueStageFilter';
import { CustomFilterOperator } from './constants';

export const getIssueStageOperator = (
  intl: IntlShape
): GridFilterOperator => {
  return {
    label: formatTranslation(intl, FiltersTranslationKeys.operatorContains),
    value: CustomFilterOperator.CONTAINS,
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!isStringArray(filterItem.value) || filterItem.value.length === 0) {
        return null;
      }

      const selectedStages = new Set(filterItem.value.filter(Boolean));

      if (!selectedStages.size) {
        return null;
      }

      return (_: unknown, row: { stageId?: string }) =>
        Boolean(row.stageId && selectedStages.has(row.stageId));
    },
    InputComponent: IssueStageFilterInput,
  };
};
